export const userService = {
    login,
    logout,
    isLoggedIn,
    getUserName,
    getUser,
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`api/auth/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a user in the response
            if (user) {
                // store user details and basic auth credentials in local storage 
                // to keep user logged in between page refreshes
             //   console.log(JSON.stringify(user));
                localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
        });
}

export const roles = {
    pssr: ['PLIS_HD prevádzka'],
    insem: ['PLIS_HD Insem. spol.'],
    technik: ['PLIS_HD Insem. technik']
}

export const hasRole = (roles) => {
    var usr = localStorage.getItem("user");
    if (usr === null)
        return false;
    var user = JSON.parse(usr);
    if (typeof user.roles === 'undefined') {
        logout();
        return false;
    }
//    console.log(roles);
//    console.log(user.roles);
    return roles.some(role => user.roles.includes(role));
}
function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function isLoggedIn() {
    //console.log('loggedin result: ' + (localStorage.getItem("user") !== null));
    return (localStorage.getItem("user") !== null);
}
function getUserName() {
    //console.log('loggedin result: ' + (localStorage.getItem("user") !== null));
    var user = JSON.parse(localStorage.getItem('user'));
    //    console.log(user);
    if (user !== null) {
        if (typeof user.fullName !== "undefined" && user.fullName.length > 0)
            return user.fullName;
        else
            return user.id;
    }
    else
        return "-";
}
function getUser() {
    //console.log('loggedin result: ' + (localStorage.getItem("user") !== null));
    var userraw = localStorage.getItem('user');
    if (userraw === null)
        return null;
    var user = JSON.parse(userraw);
    if (user === null)
        return null;
    if (typeof user.fullName === "undefined")
        user.fullName = user.id;
    if (typeof user.company === "undefined")
        user.company = '-';
    return user;
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
            }
//            console.log(data);
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}



// WEBPACK FOOTER //
// ./src/services/user.service.js